var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AttachedContent } from '../../trait/attachedcontent/AttachedContent';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { strip } from '../../../utils/serializr/schema/inner/strip';
export class AttachedBox extends AttachedContent {
    type = 'box';
    static get stripInfo() {
        return {
            extends: AttachedContent.stripInfo,
            props: {
                contents: strip((a) => a.trait.actorStrip.contents)
            }
        };
    }
}
__decorate([
    memoize
], AttachedBox, "stripInfo", null);
